import { render, staticRenderFns } from "./idUserDataCustomFieldValue.vue?vue&type=template&id=ea3fa758&"
import script from "./idUserDataCustomFieldValue.vue?vue&type=script&lang=js&"
export * from "./idUserDataCustomFieldValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports